import { FC, useEffect, useState } from 'react'
import clsx from 'clsx'
import { PlatformDataType } from 'src/interfaces/Platform.interface'
import {
  ConnectedPlatformLike,
  getConnectedPlatformLogoUrl,
  getConnectedPlatformMonogram,
} from '../utils/connectedPlatformLabel'

type ListingProfilePlatformLogoProps = {
  platform: ConnectedPlatformLike | PlatformDataType | null | undefined
  className?: string
  monogramClassName?: string
}

const MonogramBadge: FC<{ monogram: string; className?: string }> = ({ monogram, className }) => (
  <span
    className={clsx('product-listing__platform-logo-monogram', className)}
    aria-hidden="true"
  >
    {monogram}
  </span>
)

/** Platform logo with monogram visible until image loads; monogram-only on failure. */
const ListingProfilePlatformLogo: FC<ListingProfilePlatformLogoProps> = ({
  platform,
  className,
  monogramClassName,
}) => {
  const logoUrl = getConnectedPlatformLogoUrl(platform)
  const monogram = getConnectedPlatformMonogram(platform)
  const [imageLoaded, setImageLoaded] = useState(false)
  const [imageFailed, setImageFailed] = useState(false)

  useEffect(() => {
    setImageLoaded(false)
    setImageFailed(false)
  }, [logoUrl])

  if (!logoUrl || imageFailed) {
    return <MonogramBadge monogram={monogram} className={monogramClassName} />
  }

  return (
    <span className="product-listing__platform-logo-stack">
      <MonogramBadge monogram={monogram} className={monogramClassName} />
      <img
        src={logoUrl}
        alt=""
        className={clsx(
          'product-listing__platform-logo',
          'product-listing__platform-logo--overlay',
          imageLoaded && 'product-listing__platform-logo--visible',
          className
        )}
        decoding="sync"
        loading="eager"
        referrerPolicy="no-referrer"
        onLoad={() => setImageLoaded(true)}
        onError={() => setImageFailed(true)}
      />
    </span>
  )
}

export default ListingProfilePlatformLogo
